<div class="d-flex justify-content-center align-items-center vh-100">
  <div
    class="card shadow-lg rounded-4 p-4"
    style="min-width: 350px; max-width: 400px; width: 100%"
  >
    <div class="card-body">
      <h3 class="card-title mb-4 text-center">Welcome</h3>

      <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
        <div class="mb-3">
          <label for="username" class="form-label">Username</label>
          <input
            type="text"
            id="username"
            class="form-control"
            name="username"
            required
            [(ngModel)]="credentials.username"
          />
        </div>

        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input
            type="password"
            id="password"
            class="form-control"
            name="password"
            required
            [(ngModel)]="credentials.password"
          />
        </div>

        <div class="d-grid">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="!loginForm.form.valid"
          >
            Login
          </button>
        </div>
      </form>

      <div class="text-center mt-3">
        <button
          (click)="goToResetPassword()"
          class="btn btn-link text-decoration-none"
        >
          Forgot Password?
        </button>
      </div>
    </div>
  </div>
</div>
